define(["react","prop-types"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__10__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 484);
/******/ })
/************************************************************************/
/******/ ({

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(485);


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GlobalErrorBoundary", {
  enumerable: true,
  get: function get() {
    return _globalErrorBoundary.GlobalErrorBoundary;
  }
});

var _globalErrorBoundary = __webpack_require__(486);

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalErrorBoundary = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * React error boundary enclosing the entire application.
 * Smaller components in the app should have their own error boundaries as appropriate.
 * Any uncaught rendering/React lifecycle errors will be handled here.
 * https://reactjs.org/docs/error-boundaries.html
 * @extends React.Component
 */
class GlobalErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    if (this.props.logError) {
      this.props.logError({
        error,
        info
      });
    }

    this.setState({
      hasError: true,
      error,
      info
    });
  }

  render() {
    // Set renderErrorView to null to swallow the error instead of crashing the page
    if (this.state.hasError && this.props.renderErrorView) {
      return this.props.renderErrorView({
        error: this.state.error,
        info: this.state.info,
        errorViewProps: this.props.errorViewProps
      });
    }

    return _react.default.createElement(_react.default.Fragment, null, this.props.children, _react.default.createElement("div", {
      className: "global-error-boundary",
      style: {
        display: 'none'
      }
    }));
  }

}

exports.GlobalErrorBoundary = GlobalErrorBoundary;
GlobalErrorBoundary.propTypes = {
  /**
   * The enclosed application.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Function for logging the error that occurred.
   * @param {Object} obj - Object based on the arguments provided to React componentDidCatch
   * @param {Object} obj.error - Error object from React, which includes an error stack trace.
   * @param {Object} obj.info - Info object from React, which includes a componentStack trace.
   */
  logError: _propTypes.default.func,

  /**
   * Function for generating an error page view.
   * @param {Object} obj - Object based on the arguments provided to React componentDidCatch
   * @param {Object} obj.error - Error object from React, which includes an error stack trace.
   * @param {Object} obj.info - Info object from React, which includes a componentStack trace.
   * @param {Object} obj.errorViewProps - The props used by the error view to be rendered.
   * @returns - React node for the error view.
   */
  renderErrorView: _propTypes.default.func,

  /**
   * Objects of the props will be passed into the renderErrorView.
   */
  errorViewProps: _propTypes.default.instanceOf(Object)
};
GlobalErrorBoundary.defaultProps = {
  logError: null,
  renderErrorView: null,
  errorViewProps: null
};

/***/ })

/******/ })});;
